export default "__VITE_ASSET__O0mfZa6u__"